<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb name="Payment Link List" :breadcrumb="breadcrumb"/>
        </div>
        <div
            class="content-header-right text-md-right col-md-3 col-12 d-md-block d-none"
        >
        </div>
      </div>
      <div class="content-body">
        <div class="card">
          <h5 class="card-header">Search Filter</h5>
          <div class="d-flex justify-content-between align-items-center mx-50 row pt-0 pb-2">
            <div class="col-md-3 user_plan">
              <span>From Date</span>
              <datepicker :upperLimit="upperLimitDate" v-model="fromDate" class="form-control"/>
            </div>
            <div class="col-md-3 user_role">
              <span>To Date</span>
              <datepicker :upperLimit="upperLimitDate" v-model="toDate" class="form-control"/>
            </div>
            <div class="col-md-3 user_status">
              <span>Search Keyword</span>
              <input class="form-control" type="text" v-model="search" placeholder="Search here..."/>
            </div>
            <div class="col-md-3 user_status">
              <button type="button" class="btn btn-primary mt-1" @click="onSubmitFilters">Search</button>
              <button type="button" class="ml-2 btn btn-dark mt-1" @click="clear">Clear</button>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="mr-2 mt-2 ">
            <div class="row">
              <div class="col-md-12 col-12">
                <div class="d-flex align-items-center justify-content-end">
                  <button
                      type="button"
                      class="btn btn-danger"
                      @click="$router.push({ name: 'payment-link-add' })"
                  >
                    Add New Link
                  </button>
                </div>
              </div>
            </div>
          </div>
          <CommonTable
              url="v1/get-payment-link-info"
              :tableHeaderValues="tableHeaderValues"
              :actions="actions"
              :mutedData="mutedData"
              :filteredData="filteredData"
              customClass="table-hover-animation"
              :exportData="exportData"
              :hidePdfExportButton="true"
          />
        </div>
      </div>
    </div>
  </div>
  <ConfirmationModal :show="showConfirmationModal" @confirm="confirm" message="Are you sure to update the status?"
                     title="Update Status"
                     :image="`${publicPath}images/confirm.png`" @hide="showConfirmationModal = false"></ConfirmationModal>
  <DetailTextModal :show="showDescriptionModal" :text="description"
                   @hide="showDescriptionModal = false" />
</template>


<script>

import {useToast} from "vue-toastification";
import Datepicker from "vue3-datepicker";
import {ref} from "vue";

export default {
  components: {Datepicker},
  mounted() {
    this.startCountdown();
  },
  beforeUnmount() {
    // Clear interval when the component is destroyed
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
  },
  data() {
    return {
      upperLimitDate: new Date(),
      countdownInterval: null,
      filteredData:{},
      search:'',
      toDate: ref(new Date()),
      fromDate: ref(new Date()),
      exportData:{
        cta: (exportType) => {
          let requestData = {
            exportAs: exportType,
            reportType: 'payment_links',
            // payment_type: 1,
          }


          this.downloadReport(requestData)
        }
      },
      breadcrumb: [
        {name: 'App'},
        {name: 'Payment Link'},
      ],
      showConfirmationModal: false,
      toastG: useToast(),
      currentRow: null,
      currentIndex: null,
      description:'',
      showDescriptionModal:false,
      tableHeaderValues: [
        {
          title: 'Id',
          valueKey: 'token',
          html: true,
          alter: function (value, row) {
            var html = "";
            if (value) {
              html = `<span class="text-primary">${value}</span>`;
              if (row.added_by && row.added_by_user) {
                if(row.added_by != row.user_id){
                  html = `
                <div class="row">
                <div class="col-12">
                <span class="text-primary ">${value}</span>
                </div><p><div class="badge badge-light-danger ml-1" style="margin-top: 0.3rem">${row.added_by_user.email+'/'+row.added_by_user.first_name+' '+row.added_by_user.last_name}</div></p></div>`
                }
              }
              return html;
            } else {
              html = "-";
              return html;
            }
          }
        },
        {
          title: 'Total Transactions',
          valueKey: 'transactions_count',
          html: true,
          alter: function (value) {
            var html = ''
              html = `<span class="text-info">${value}</span>`


            return html


          }
        },
        {
          title: 'Channel',
          valueKey: 'channel.name',
          html: true,
          alter: function (value,row) {
            var html = ''
              html = `<span class="text-warning">${value+'/'+row.channel.code}</span>`


            return html


          }
        },
        {
          title: 'Amount',
          valueKey: 'amount',
          html: true,
          customClass: 'text-center',
          alter:  (value, obj) => {
            var html = ''
            if (value && obj.type == 0)
              html = `<span  class=" font-weight-bolder text-dark row justify-content-center">${parseFloat((value)/100).toFixed(this.amountDecimalPlaces)} <div class="badge badge-light-success ml-1">${obj.currency.code}</div></span>
               <div class="badge badge-light-warning mt-1">Single</div>`
            else if (value && obj.type == 1) {
              html = `<span  class=" font-weight-bolder text-dark row justify-content-center">${parseFloat((value)/100).toFixed(this.amountDecimalPlaces)} <div class="badge badge-light-success ml-1">${obj.currency.code}</div></span>
               <div class="badge badge-light-info mt-1">Multiple</div>`
            }

            // html += `<div class="badge badge-light-success mt-1">${obj.currency.code}</div>`

            return html


          }
        },
        {
          title: 'Schemas',
          valueKey: 'schemas',
          html: true,
          alter: function (value, obj) {
            var html = ''
            if (value){
              html = `<div class="grid">`
              if(obj.schemas.length){
                obj.schemas.forEach((item) => {

                  html += `<div class="row"><div class="badge badge-light-primary mt-sm-1">${item.name}</div></div>`
                })
              }

              html += ` </div>`
            }


            return html
          }
        },
        {
          title: 'Status',
          valueKey: 'exipres_in',
          html: true,
          alter:  (value, obj) => {
            var givenDate = new Date(obj.created_at);
            var givenSeconds = givenDate.getTime() / 1000;
            var currentDate = new Date();
            var currentSeconds = currentDate.getTime() / 1000;
            var html = ''
            if(!obj.exipres_in){
              html = `<div class="badge badge-light-dark" style="margin-top: 0.5rem">Lifetime</div>`
            }
            else if ((obj.exipres_in < (currentSeconds-givenSeconds))) {
              html = `

                <div class="badge badge-light-danger ml-1 " style="margin-top: 0.5rem">Expired</div>`

            }else{
              // let expiry = parseFloat(obj.exipres_in-(currentSeconds-givenSeconds)).toString()
              html = `<span class="countdown-timer" data-expires="${obj.exipres_in}" data-created="${obj.created_at}"></span>`
              // html = `<div class="badge badge-light-warning ml-1" style="margin-top: 0.5rem">${expiry.split('.')[0]} seconds left</div>\``
            }

            let statusHtml = ''
            if (obj.status == 1)
              statusHtml = `<div class="badge badge-pill dynamic-status  badge-glow badge-success">${obj.status_str}</div>`
            else if (obj.status == 2)
              statusHtml = `<div class="badge badge-pill dynamic-status  badge-glow badge-danger">${obj.status_str}</div>`
            else
              statusHtml = `<div class="badge badge-pill dynamic-status  badge-glow badge-warning"">${obj.status_str}</div>`


            if(!obj.exipres_in){
              html = `
                <div class="row justify-content-center">
                    <div class="">
                    ${statusHtml}
                    </div>
                ${html}
                </div>`
            }
            else if((obj.exipres_in < (currentSeconds-givenSeconds))){
              // means expired
              html = `
                <div class="row justify-content-center">
                ${html}
                </div>`
            }else{
              html = `
                <div class="row justify-content-center">
                    <div class="">
                    ${statusHtml}
                    </div>
                ${html}
                </div>`
            }


            return html


          },
        },
        {
          title: 'Description',
          valueKey: 'description',
          html: true,
          alter: function(value) {
            var html = "";
            if (value) {
              html = `<span class="text-success" style="cursor: pointer" title="click to view full description">${value.substring(0,12)+'...'}</span>`;
              return html;
            } else {
              html = "-";
              return html;
            }
          },
          cta: (row) => {
            this.description = row.description
            this.showDescriptionModal = true
          }
        },
        {
          title: 'Callback Url',
          valueKey: 'callback_url',
        },
        {
          title: 'Redirect Url',
          valueKey: 'redirect_url',
        },
        {
          title: 'Payment Url',
          valueKey: 'payment_url',
          html: true,
          alter: function (value, obj) {
            var html = ''
            if (value)
              html = `<button type="button" class="btn btn-outline-info round waves-effect btn-sm">Copy Link</button>`


            return html


          },
          cta: (row) => {
            this.copyText(row.payment_url);
          }
        },
        {
          title: 'Transaction Time/Date',
          valueKey: 'created_at',
          alter: (value) => {
            return this.customFormatDateTime(value)
          }
        },
      ],
      actions: [
        {
          conditionalRendering: true,
          toggleSwitch:true,
          class: 'mt-1',
          toggleSwitchCondition: (row) => {
            if (row.status == 1) {
              return true
            }
            return false
          },
          condition: (row) => {
            var givenDate = new Date(row.created_at);
            var givenSeconds = givenDate.getTime() / 1000;
            var currentDate = new Date();
            var currentSeconds = currentDate.getTime() / 1000;

            if(row.exipres_in && row.exipres_in != 0 && row.exipres_in < (currentSeconds-givenSeconds)){
              // means expired
              return false
            }

            if (row.status == 1 || row.status == 2) {
              return true
            }
            return false
          },
          cta: (row, index) => {
            this.updateStatus(row, index)
            // this.currentRow = row
            // this.currentIndex = index
            // this.showConfirmationModal = true
          }
        },
        {
          title: 'Transactions',
          class: 'btn-warning mt-1',
          cta: (row) => {
            this.$store.commit('setPaymentLinkDetail',row)
            this.$router.push({name : 'payment-link-view'})
          }
        },
        {
          title: 'Attempts',
          class: 'btn-primary mt-1 ml-1',
          cta: (row) => {
            this.$router.push({name: 'payment-link-attempt',params: {id:row.token}})
          }
        },
      ],
      mutedData: [],
    }
  },
  methods: {
    startCountdown() {
      this.countdownInterval = setInterval(() => {
        document.querySelectorAll('.countdown-timer').forEach((element) => {
          let expiresIn = parseInt(element.getAttribute('data-expires'));
          let createdAt = new Date(element.getAttribute('data-created')).getTime();
          let currentTime = new Date().getTime();
          let elapsedSeconds = Math.floor((currentTime - createdAt) / 1000);
          let remainingSeconds = expiresIn - elapsedSeconds;

          // Find the closest row and the dynamic status element
          let row = element.closest('tr');
          let statusElement = row ? row.querySelector('.dynamic-status') : null;

          if (remainingSeconds <= 0) {
            // Clear the status if it exists
            if (statusElement) {
              statusElement.innerHTML = "";
            }
            element.innerHTML = `<span class="badge badge-light-danger ml-1" style="margin-top: 0.5rem">Expired</span>`;
          } else {
            element.innerHTML = `<small style="margin-top: 0.5rem" class=" font-weight-bolder row  text-danger justify-content-center">Expires In</small><span class="badge badge-light-warning" style="margin-top: 0.5rem">${this.formatTime(remainingSeconds)}</span>`;
          }
        });
      }, 1000);

    },

    formatTime(seconds) {
      let days = Math.floor(seconds / (3600 * 24));
      let hours = Math.floor((seconds % (3600 * 24)) / 3600);
      let minutes = Math.floor((seconds % 3600) / 60);
      let sec = seconds % 60;

      return `${days}d ${hours}h ${minutes}m ${sec}s`;
    },
    onSubmitFilters() {

      let filterData = {}

      if(this.search != ''){
        filterData.paymentLinkToken = this.search
      }
      if(this.toDate){
        filterData.toDate = this.formatDate(this.toDate)
      }
      if(this.fromDate){
        filterData.fromDate = this.formatDate(this.fromDate)
      }

      this.filteredData = filterData

    },
    clear(){
      this.toDate = null
      this.fromDate = null
      this.search = ''
      this.filteredData = {}
    },

    confirm() {
      let data = {
        paymentLinkId: this.currentRow.id
      };
      if (this.currentRow.status == 2) {
        data.status = 1
      } else {
        data.status = 2
      }
      this.makeRequest('post', 'v1/update-payment-link', data).then(callResponse => {

        this.loader = false
        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if (code == 200) {
            this.showConfirmationModal = false
            this.mutedData = {
              index: this.currentIndex,
              status_str: callResponse.response.data.data.status_str,
              status: data.status
            }
          }
          // this.currentIndex = null
          // this.currentRow = null
        }

      });


    },
    updateStatus(row,index) {
      let data = {
        paymentLinkId : row.id
      };
      if(row.status == 2){
        data.status = 1
      }else{
        data.status = 2
      }

      this.makeRequest('post', 'v1/update-payment-link', data).then(callResponse => {

        this.loader = false
        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if (code == 200) {
            this.mutedData = {
              index: index,
              status_str : callResponse.response.data.data.status_str,
              status: data.status
            }
          }
        }

      });

    },
  }
}
</script>

